import { render, staticRenderFns } from "./WeatherEffects.vue?vue&type=template&id=4964ed78&scoped=true"
import script from "./WeatherEffects.vue?vue&type=script&lang=js"
export * from "./WeatherEffects.vue?vue&type=script&lang=js"
import style0 from "./WeatherEffects.vue?vue&type=style&index=0&id=4964ed78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964ed78",
  null
  
)

export default component.exports